import { render, staticRenderFns } from "./FileDocument.vue?vue&type=template&id=a82dbbf4&scoped=true"
import script from "./FileDocument.vue?vue&type=script&lang=js"
export * from "./FileDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a82dbbf4",
  null
  
)

export default component.exports